<template>
  <div class="commodityList-h5" :style="commodityListStyl" v-if="!showPlacehold">
  <!-- 标题 -->
    <!-- <div class="commodity-list-title-h5">标题</div> -->
    <div class="commodity-list-box-h5">
      <!-- 热门 -->
      <div class="commodity-hot-list" :style="listStyl(goodsRank.templateType)">
        <div class="commodity-sub-title">
          <img :src="goodsRank.templateType == 1 ? hotIcon : boomIcon" alt="">
          <span>{{goodsRank.templateType == 1 ? '最新课程' : '热门课程'}}</span>
        </div>
        <div
          v-for="(item,index) in list" :key="item.goodsId"
          :style="listItemStyl"
          class="list-item-box-h5"
          @click="handleOpenPage(item)">
          <img :src="item.pic" alt="" class="list-item-l-h5">
          <div class="list-item-r-h5">
            <div>
              <div class="list-item-title-h5">{{item.name | filterStr}}</div>
              <span
                class="list-item-tags-h5"
                v-show="goodsRank.showGoodsLabel && item.labelNameList.length"
                v-if="item.labelNameList !=null"
              >
              {{ item.labelNameList[0] | filterTag}}
            </span>
            </div>
            <div class="list-item-price-h5" v-if="goodsRank.showGoodsPrice || goodsRank.buyButton">
              <span class="salePrice-h5" v-if="goodsRank.showGoodsPrice">{{item.isFree == 1 ? '免费' : '￥'+ item.price}}</span>
              <span class="apply-btn-h5" v-if="goodsRank.buyButton && goodsRank.buttonLabel">{{goodsRank.buttonLabel}}</span>
            </div>
          </div>
          <img :src="tagList[index]" v-show="index < 3" class="lacehold-img-h5" />
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <img
      src="https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/06/1654846362484.png"
      alt="占位图"
      class="lacehold-img-h5">
  </div>
  
</template>
<script>
import goodsCommon from '../mixins/goodsCommon';
export default {
  name: 'goodsRankH5',
  mixins: [goodsCommon],
  props: {
    data: {
      type: [Object, Array],
      default: () => {},
    },
  },
  filters: {
    filterStr(val) {
      if (val.length < 27) {
        val = val ? val : ''
      } else {
        val = val.substr(0,27) + '...'
      }
      return val
    },
    filterTag(val) {
      let str = '';
      if (val) {
        if (val.length < 15) {
          str = val ? val : ''
        } else {
          str = val.substr(0,15) + '...'
        }
      }
      return str;
    }
  },
  computed: {
    commodityListStyl() {
      let { tempData: { goodsRank } } = this.data;
      return {
        margin: '0 auto',
        marginTop: goodsRank.blockMargeTop ? goodsRank.blockMargeTop + 'px' : 0,
        marginBottom: goodsRank.blockMargeBottom ? goodsRank.blockMargeBottom + 'px': 0,
        background: goodsRank.blockBGClolor ? goodsRank.blockBGClolor : '',
      }
    },
    listStyl() {
      return function(val) {
        return {
          backgroundImage: val == 1 ? 
          'url(https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/06/1654745398216.png)': 
          'url(https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/06/1654745450516.png)',
          backgroundSize:'100%',
          backgroundRepeat:'no-repeat',
        }
      }
    },
    listItemStyl() {
      return {
        display: 'flex',
        position: 'relative',
        background: '#fff',
        border: '1px solid #F0F0F0',
        boxSizing: 'border-box'
      }
    },
    topTagStyl() {
      return {
        position: 'absolute'
      }
    }
  },
  data() {
    let { tempData: { goodsRank } } = this.data;
    let branchId = localStorage.getItem('branchId');
    let saasId = localStorage.getItem('saasId');
    return {
      showPlacehold: false,
      goodsRank,
      branchId,
      saasId,
      hotIcon: 'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/06/1654742767220.png',
      boomIcon: 'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/06/1654742772061.png',
      list: [],
      tagList:[
        'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/06/1654760394561.png',
        'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/06/1654760427643.png',
        'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/06/1654760560792.png'
      ]
    }
  },
  created() {
    console.log(this.data,'goodsRankH5')
    let { tempData: { goodsRank } } = this.data;
    if (!goodsRank) {
      this.showPlacehold = true;
      return
    }
    
    if (!this.branchId || this.branchId == -1 || this.branchId == null) return;
    if (goodsRank.contentSource !== '1') {
      // 选择分类 选择全部
      this.getDataList()
    } else {
      this.getFreeList(goodsRank.goodsList, goodsRank.goodsType, goodsRank.showTotal,11);
    }
  },
  methods: {
    async getDataList(){
      let {
        showTotal,
        contentSource,
        commendsRule,
        code,
        articleClassID,
        goodsSelectType
      } = this.goodsRank;
      let data = {
        branchId: this.branchId,
        saasId: this.saasId,
        categoryCode: contentSource === '3' ? '' : code,
        categoryId: contentSource === '3' ? '' : articleClassID,
        name: '',
        type: commendsRule ? commendsRule : 3,
        goodsKinds: goodsSelectType
      }
      showTotal = showTotal ? showTotal : 10
      let params = {
        pageNum: 1,
        pageSize: showTotal < 11 || showTotal === 0 ? showTotal : 10
      }
      try {
        let res = await this.$apis.news.getChannelGoodsList(data,params);
        if (res.success) {
          this.list = this.filterPrice(res.data.list);
        }
      } catch(e) {
        console.log(e)
      }
    },
    getFreeList(goodsList, goodsType, showTotal,max) {
      if (!goodsList.length) {
        this.goodsItemList = [];
        return;
      }
      showTotal = showTotal ? showTotal : max-1;
      let size = showTotal < max || showTotal === 0 ? showTotal : max -1;
      let ids = goodsList.map(item => {
        return item.id
      })
      let idsOne = [];
      let idsTwo = [];
      let idsThree = [];
      goodsList.forEach(item => {
        if (item.goodsKinds == 1) {
          idsOne.push(item.id)
        } else if (item.goodsKinds == 2) {
          idsTwo.push(item.id)
        } else if (item.goodsKinds == 3){
          idsThree.push(item.id)
        }
      })
      let data = {
        branchId: this.branchId,
        saasId: this.saasId,
        list: [
          {
            goodsKinds: 1, // 自建培训
            ids: idsOne,
          },
          {
            goodsKinds: 2, // 分销
            ids: idsTwo,
          },
          {
            goodsKinds: 3, // 自建实物
            ids: idsThree,
          }
        ],
      }
      this.$apis.news.getFreeGoodsList(data).then((res) => {
        if (res.success) {
          let list = this.filterPrice(res.data,ids);
          this.list = list.splice(0,size);
        }
      })
    },
    // filterPrice(list) {
    //   if (list.length) {
    //     list.map(item => {
    //       item.price = item.isFree == 1 ? 0 : item.price;
    //       if (item.price instanceof Number) {
    //         item.price = item.price.toFixed(2);
    //       }
    //     })
    //   }
    //   return list
    // },
    // 跳转商品详情
    handleOpenPage(data) {
      this.openH5GoodsDetail(data);
    }
  }
}
</script>
<style lang="less" scoped>
  .commodityList-h5 {
    // width: 690px;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 0 30px;
    .commodity-list-title-h5 {
      margin: 24px 0;
      padding-left: 40px;
      font-family: PingFangSC-Medium, sans-serif;
      font-size: 34px;
      color: #333;
      font-weight: bold;
      text-align: left;
      box-sizing: border-box;
    }
    .commodity-list-box-h5 {
      .commodity-sub-title {
        display: flex;
        color: #E5624F;
        font-weight: bold;
        padding: 40px 28px;
        align-items: center;
        box-sizing: border-box;
        margin-bottom: 20px;
        span {
          font-size: 30px;
          display: inline-block;
          font-family: CN Heavy Bold;
          text-align: left;
        }
        img {
          height: 30px;
          margin-right: 12px;
        }
      }
      .list-item-box-h5 {
        padding: 30px 38px 30px 30px;
        border-radius: 16px;
        margin-bottom: 20px;
      }
      .list-item-l-h5 {
        width: 216px;
        border-radius: 16px;
        max-height: 200px;
      }
      .list-item-r-h5 {
        margin-left: 25px;
        text-align: left;
        // height: 162px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .list-item-title-h5 {
          font-size: 26px;
          color: #333;
          font-family: PingFangSC-Medium, sans-serif;
          margin-bottom: 8px;
          width: 381px;
        }
        .list-item-tags-h5 {
          font-size: 21px;
          color: #C89A5A;
          padding: 1px 8px;
          background: #FAF7F1;
          border-radius: 2px;
          display: inline-block;
          margin-right: 10px;
        }
        .list-item-price-h5 {
          .salePrice-h5 {
            font-size: 30px;
            color: #F55A3A;
            font-family: PingFangSC-Medium, sans-serif;
          }
          .apply-btn-h5 {
            font-size: 24px;
            color: #fff;
            font-family: PingFangSC-Regular, sans-serif;
            padding: 16px 21px;
            background: #227FFF;
            border-radius: 32px;
            box-sizing: border-box;
            position: absolute;
            bottom: 32px;
            right: 30px;
          }
        }
      }
      .lacehold-img-h5 {
        width: 55px;
        position: absolute;
        left: 28px;
        top: 0;
      }
    }
  }
  .lacehold-img-h5 {
    width: 100%;
  }
</style>